import axios from 'axios';
import authHeader from './auth-header';

const API_URL = `${process.env.REACT_APP_MY_HOST}/v7/admin/language`;
const FORWARD_API_URL = `${process.env.REACT_APP_FORWARD_HOST}/v7/admin/language`;
const FORWARD_API_URL_2 = `${process.env.REACT_APP_FORWARD_HOST3}/v7/admin/language`;

class LanguageService {

    getLanguage(tool) {
        return axios.get(`${API_URL}?tool=${tool}`, { headers: authHeader() });
    }

    createLanguage(tool, key, vi, en) {
        return axios.post(`${API_URL}?tool=${tool}&key=${key}&vi=${vi}&en=${en}`, null, { headers: authHeader() });
    }

    createLanguageJson(tool, jsonData) {
        return axios.post(`${API_URL}-json?tool=${tool}`, jsonData, {
            headers: {
                ...authHeader(),
                'Content-Type': 'application/json'
            }
        });
    }

    updateLanguage(tool, id, key, vi, en) {
        return axios.post(`${API_URL}-update?tool=${tool}&id=${id}&key=${key}&vi=${vi}&en=${en}`, null, { headers: authHeader() });
    }

    deleteLanguage(tool, id, key) {
        return axios.post(`${API_URL}-delete?tool=${tool}&id=${id}&key=${key}`, null, { headers: authHeader() });
    }

    deleteListLanguage(tool, languageList) {
        return axios.post(`${API_URL}-delete-list?tool=${tool}`, languageList, {
            headers: {
                ...authHeader(),
                'Content-Type': 'application/json'
            }
        });
    }



    commitLanguage(tool) {
        return axios
            .get(`${FORWARD_API_URL}/commit?tool=${tool}`, { headers: authHeader() })
            .then(forwardRes => {
                // Khi request forward thành công, gọi request tiếp theo
                return axios.get(`${API_URL}/commit?tool=${tool}`, { headers: authHeader() });
            })
            .then(currentRes => {
                // Khi request current thành công, gọi request đến Home NUC
                return axios.get(`${FORWARD_API_URL_2}/commit?tool=${tool}`, { headers: authHeader() });
            });
    }
}

export default new LanguageService();
